export const SET_ANALYSIS = 'provider/SET_ANALYSIS';
export const SET_CHARTDATA = 'provider/SET_CHARTDATA';
export const SET_PDF_LINK = 'provider/SET_PDF_LINK';
export const SET_GENERATING_PDF = 'provider/SET_GENERATING_PDF';
export const SET_FETCHING_ANALYSIS = 'provider/SET_FETCHING_ANALYSIS';
export const SET_FETCHING_CHARTDATA = 'provider/SET_FETCHING_CHARTDATA';
